export const source_tags = [
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "OFSS",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "ADANIPORTS",
    sources: ["Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "MOTHERSON",
    sources: ["Alpha 200"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "INDHOTEL",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "BEL",
    sources: ["Nifty Alpha 50", "Alpha 200", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "TATAMOTORS",
    sources: ["Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "BSOFT",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "PNB",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "CUMMINSIND",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "DIXON",
    sources: ["Nifty Alpha 50", "Alpha 500", "Alpha 200"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "TVSMOTOR",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "BAJAJ-AUTO",
    sources: ["Nifty Alpha 50", "Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "AUROPHARMA",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "COALINDIA",
    sources: ["Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "POWERGRID",
    sources: ["Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "BHEL",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "RECLTD",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "BHARTIARTL",
    sources: ["Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "NTPC",
    sources: ["Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "ABB",
    sources: ["Nifty Alpha 50", "Alpha 500", "Alpha 200"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "INDUSTOWER",
    sources: ["Alpha 200"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "ZYDUSLIFE",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "LT",
    sources: ["Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "M&M",
    sources: ["Alpha 50", "Alpha 200"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "APOLLOTYRE",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "HAL",
    sources: ["Nifty Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "DLF",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "SIEMENS",
    sources: ["Alpha 500", "Alpha 200", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "MCX",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "HINDCOPPER",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "CANBK",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "ONGC",
    sources: ["Alpha 50", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "LUPIN",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "TRENT",
    sources: ["Nifty Alpha 50", "Alpha 500", "Alpha 200", "Alpha 100"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "LTF",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "PFC",
    sources: ["Nifty Alpha 50"],
  },
  {
    datetime: "2024-08-12T00:00:00",
    symbol: "GLENMARK",
    sources: ["Nifty Alpha 50", "Alpha 500"],
  },
];
